import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const getPlantillaByPersonal = (codigo) => {
  const plantillas = {
    U0000006: '/assets/U0000007_plantilla.jpg',
    U0000007: '/assets/U0000007_plantilla.jpg',
    U0000008: '/assets/U0000008_plantilla.jpg',
    U0000022: '/assets/U0000022_plantilla.jpg',
    U0000025: '/assets/U0000025_plantilla.jpg',
    U0000033: '/assets/U0000033_plantilla.jpg',
    U0000036: '/assets/U0000033_plantilla.jpg',
    U0000040: '/assets/U0000040_plantilla.jpg',
    U0000047: '/assets/U0000047_plantilla.jpg',
    U0000062: '/assets/U0000062_plantilla.jpg',
    U0000063: '/assets/U0000063_plantilla.jpg',
    U0000066: '/assets/U0000066_plantilla.jpg',
    U0000067: '/assets/U0000067_plantilla.jpg',
    U0000068: '/assets/U0000068_plantilla.jpg',
    U0000069: '/assets/U0000069_plantilla.jpg',
    U0000070: '/assets/U0000070_plantilla.jpg',
    U0000072: '/assets/U0000072_plantilla.jpg',
    U0000073: '/assets/U0000073_plantilla.jpg',
    U0000074: '/assets/U0000074_plantilla.jpg',
    U0000076: '/assets/U0000076_plantilla.jpg',
    U0000086: '/assets/U0000086_plantilla.jpg',
  };
  return plantillas[codigo] || null;
};

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 9,
    padding: 0,
    backgroundColor: '#ffffff',
  },
  pageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  headerTitleContainer: {
    position: 'absolute',
    top: 90,
    left: 0,
    width: '100%',
    textAlign: 'center',
  },
  headerTitleText: {
    fontSize: 11,
    fontWeight: 'bold',
  },
  mainContainer: {
    position: 'absolute',
    top: 150,
    left: 75,
    width: 450,
  },
  mainContainerPage2: {
    position: 'absolute',
    top: 150,
    left: 75,
    width: 450,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#000000',
    borderLeftWidth: 0.5,
    borderLeftColor: '#000000',
    borderRightWidth: 0.5,
    borderRightColor: '#000000',
    alignItems: 'center',
    minHeight: 15,
  },
  cellLabel: {
    width: 80,
    backgroundColor: '#636363',
    color: 'white',
    padding: 2,
    fontSize: 8,
    fontWeight: 'bold',
    height: '100%',
  },
  cellValue: {
    flex: 1,
    paddingLeft: 5,
    fontSize: 9,
  },
  textBlockBetween: {
    fontSize: 7.5,
    textAlign: 'justify',
    marginTop: 10,
    marginBottom: 10,
    lineHeight: 1.2,
  },
  tableHeaderFull: {
    backgroundColor: '#636363',
    flexDirection: 'row',
    borderWidth: 0.5,
    borderColor: '#000',
    borderBottomWidth: 0,
  },
  tableHeaderText: {
    width: '100%',
    textAlign: 'center',
    color: 'white',
    fontWeight: 'bold',
    padding: 3,
    fontSize: 9,
  },
  conclusionContent: {
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: '#000',
    padding: 8,
  },
  signatureContainer: {
    marginTop: 5,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  signatureImage: {
    width: 140,
    height: 'auto',
  },
  imagesContainer: {
    marginTop: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  imageWrapper: {
    width: '48%',
    height: 180,
    marginBottom: 10,
    border: '1px solid #ccc',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageStyle: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
});

const PatientRow = ({ label, value, label2, value2 }) => (
  <View style={styles.tableRow}>
    <View style={styles.cellLabel}>
      <Text>{label}</Text>
    </View>
    <View style={styles.cellValue}>
      <Text>{value || ''}</Text>
    </View>
    {label2 && (
      <>
        <View style={[styles.cellLabel, { borderLeftWidth: 0.5 }]}>
          <Text>{label2}</Text>
        </View>
        <View style={styles.cellValue}>
          <Text>{value2 || ''}</Text>
        </View>
      </>
    )}
  </View>
);

const MedicalRow = ({ label, valDerecha, valIzquierda }) => (
  <View style={styles.tableRow}>
    <View style={[styles.cellLabel, { width: '34%' }]}>
      <Text>{label}</Text>
    </View>
    <View style={[styles.cellValue, { width: '33%', textAlign: 'center', borderRightWidth: 0.5 }]}>
      <Text>{valDerecha || ''}</Text>
    </View>
    <View style={[styles.cellValue, { width: '33%', textAlign: 'center' }]}>
      <Text>{valIzquierda || ''}</Text>
    </View>
  </View>
);

export const EcografiaPdf = ({ data, patientData }) => {
  console.log('ver toda la data: ', data);
  const paciente = patientData || {};
  const informes = data?.informes || {};
  const nombreCompleto = `${paciente.nombres || ''} ${paciente.apellido_paterno || ''} ${
    paciente.apellido_materno || ''
  }`;
  const plantillaUrl = getPlantillaByPersonal(data.personal_codigo);

  const imageKeys = [
    'eco_derecha_con_medida',
    'eco_izquierda_con_medida',
    'eco_derecha_sin_medida',
    'eco_izquierda_sin_medida',
  ];

  return (
    <Document>
      {/* PÁGINA 1: INFORME */}
      <Page size="A4" style={styles.page}>
        <View style={styles.pageWrapper}>
          {plantillaUrl && <Image src={plantillaUrl} style={styles.backgroundImage} />}

          <View style={styles.headerTitleContainer}>
            <Text style={styles.headerTitleText}>INFORME ECOGRAFICO DE CADERAS</Text>
            <Text style={styles.headerTitleText}>POR EL MÉTODO DE GRAF</Text>
          </View>

          <View style={styles.mainContainer}>
            {/* CUADRO 1: PACIENTE */}
            <View style={{ borderTopWidth: 0.5, borderColor: '#000' }}>
              <PatientRow label="PACIENTE:" value={nombreCompleto} />
              <PatientRow
                label="D.N.I.:"
                value={paciente.numero_de_dni}
                label2="FECHA INF.:"
                value2={data.fecha_de_registro || informes.fecha_de_registro}
              />
              <PatientRow
                label="E-MAIL:"
                value={paciente.correo_electronico}
                label2="FECHA NAC.:"
                value2={paciente.fecha_de_nacimiento}
              />
            </View>

            <Text style={styles.textBlockBetween}>
              Ecografía: Se realiza ultrasonido de caderas con método de Graf, colocación del
              paciente en cuna de posición y uso de guía de transductor. Transductor lineal
              multihertz, obteniendo imagen estandarizada de Graf, se valida lista de verificación
              anatómica (Lista de verificación 1) 1. Borde osteocondral 2, cabeza femoral 3. Pliegue
              sinovial 4. Cápsula. 5. Labrum 6. Techo cartilaginoso 7. Techo óseo 8. Turning point;
              así como la validez de la imagen (lista de verificación 2) al observar 1. Borde
              inferior del iliaco 2. Plano correcto y 3. Labrum.
            </Text>

            {/* CUADRO 2: DESCRIPCIÓN */}
            <View style={styles.tableHeaderFull}>
              <Text style={styles.tableHeaderText}>Descripción ultrasonográfica de caderas</Text>
            </View>
            <View style={{ borderTopWidth: 0.5, borderColor: '#000' }}>
              <View style={[styles.tableRow, { backgroundColor: '#636363' }]}>
                <Text style={[styles.cellLabel, { width: '34%' }]}>Detalle:</Text>
                <Text style={[styles.cellLabel, { width: '33%', textAlign: 'center' }]}>
                  Cadera derecha:
                </Text>
                <Text style={[styles.cellLabel, { width: '33%', textAlign: 'center' }]}>
                  Cadera izquierda:
                </Text>
              </View>
              <MedicalRow
                label="Centraje:"
                valDerecha={informes.derecha_1}
                valIzquierda={informes.izquierda_1}
              />
              <MedicalRow
                label="Techo óseo:"
                valDerecha={informes.derecha_2}
                valIzquierda={informes.izquierda_2}
              />
              <MedicalRow
                label="Techo cartilaginoso:"
                valDerecha={informes.derecha_3}
                valIzquierda={informes.izquierda_3}
              />
              <MedicalRow
                label="Ceja ósea:"
                valDerecha={informes.derecha_4}
                valIzquierda={informes.izquierda_4}
              />
              <MedicalRow
                label="Porcentaje cobertura:"
                valDerecha={informes.derecha_5}
                valIzquierda={informes.izquierda_5}
              />
              <MedicalRow
                label="Núcleo osificación de cabeza:"
                valDerecha={informes.derecha_6}
                valIzquierda={informes.izquierda_6}
              />
              <MedicalRow
                label="Tipo de cadera por anatomía:"
                valDerecha={informes.derecha_7}
                valIzquierda={informes.izquierda_7}
              />
              <MedicalRow
                label="Ángulo Alfa:"
                valDerecha={informes.derecha_8 + '°'}
                valIzquierda={informes.izquierda_8 + '°'}
              />
              <MedicalRow
                label="Ángulo Beta:"
                valDerecha={informes.derecha_9 + '°'}
                valIzquierda={informes.izquierda_9 + '°'}
              />
              <MedicalRow
                label="Tipo de cadera definitva:"
                valDerecha={informes.derecha_10}
                valIzquierda={informes.izquierda_10}
              />
            </View>

            {/* CUADRO 3: CONCLUSIONES Y SUGERENCIAS */}
            <View style={[styles.tableHeaderFull, { marginTop: 15 }]}>
              <Text style={styles.tableHeaderText}>Conclusiones y sugerencias</Text>
            </View>
            <View style={styles.conclusionContent}>
              <Text style={{ marginBottom: 10, fontSize: 9, textAlign: 'center' }}>
                {informes.diagnostico_conclusion || '—'}
              </Text>
              <View style={styles.signatureContainer}>
                <Image src="/assets/valores_ecografia.png" style={styles.signatureImage} />
              </View>
            </View>
          </View>
        </View>
      </Page>

      {/* PÁGINA 2: ANEXO */}
      <Page size="A4" style={styles.page}>
        <View style={styles.pageWrapper}>
          {plantillaUrl && <Image src={plantillaUrl} style={styles.backgroundImage} />}
          <View style={styles.headerTitleContainer}>
            <Text style={styles.headerTitleText}>ANEXO - IMÁGENES DE ECOGRAFIA</Text>
          </View>
          <View style={styles.mainContainerPage2}>
            <View style={{ borderTopWidth: 0.5, borderColor: '#000' }}>
              <PatientRow label="PACIENTE:" value={nombreCompleto} />
              <PatientRow
                label="D.N.I.:"
                value={paciente.numero_de_dni}
                label2="FECHA INF.:"
                value2={data.fecha_de_registro || informes.fecha_de_registro}
              />
            </View>
            <View style={styles.imagesContainer}>
              {imageKeys.map((key) => {
                const rawUrl =
                  data[key] || (data.imagenes_asociadas && data.imagenes_asociadas[key]);
                if (rawUrl) {
                  const cleanUrl =
                    typeof rawUrl === 'string' ? rawUrl.replace(/\\\//g, '/') : rawUrl;
                  return (
                    <View key={key} style={styles.imageWrapper}>
                      <Image src={cleanUrl} style={styles.imageStyle} />
                    </View>
                  );
                }
                return null;
              })}
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
